"use client";

import type { VariantProps } from "class-variance-authority";
import type { buttonVariants } from "@/app/_ui/components/core/Button";

import { isSignedIn } from "@utilities/auth";
import { env } from "@/env";

import { Button } from "@/app/_ui/components/core/Button";
import { ICON_ALIGN_OPTIONS } from "@ui/tokens/icon-types";
import { useAuthDialog } from "./useAuthDialog";
import type { AuthDialogView } from "./AuthDialogContext";

interface AuthLinkProps {
  href: string;
  initialView?: Extract<AuthDialogView, "sign-up" | "sign-in">;
  children: React.ReactNode;
  className?: string;
  buttonVariants?: VariantProps<typeof buttonVariants>;
  icon?: React.ReactNode;
  iconPosition?: ICON_ALIGN_OPTIONS;
  ariaLabel?: string;
  disabled?: boolean;
}

export function AuthLink({
  href,
  initialView = "sign-up",
  children,
  className,
  buttonVariants: variants,
  icon,
  iconPosition,
  ariaLabel,
  disabled,
}: AuthLinkProps) {
  const { openAuthDialog } = useAuthDialog();

  const appUrl = `${env.NEXT_PUBLIC_WEB_APP_URL}${href}`;

  const handleClick = () => {
    if (isSignedIn()) {
      window.location.href = appUrl;
    } else {
      openAuthDialog({ initialView, redirectTo: href });
    }
  };

  return (
    <Button
      className={className}
      disabled={disabled}
      icon={icon}
      iconPosition={iconPosition}
      aria-label={ariaLabel}
      onClick={handleClick}
      {...variants}
    >
      {children}
    </Button>
  );
}
